import React from 'react';
import { Link } from 'react-router-dom'; 
import './location.css'

const Location = () => {
  return (
    <section className="section3">
      <h1 className='you'>Your next home could be here</h1>
      <div className="section3-columns">
        <div className="section3-column">
          <Link to="/kimbo">Kimbo</Link><br /><br />
          <Link to="/k-road">K-Road</Link><br /><br />
          <Link to="/juja">Juja</Link>
        </div>
        <div className="section3-column">
          <Link to="/gate a">Gate A</Link><br /><br />
          <Link to="/gate b">Gate B</Link><br /><br />
          <Link to="/gate c">Gate C</Link>
        </div>
        <div className="section3-column">
          <Link to="/gate d">Gate D</Link><br /><br />
          <Link to="/gashororo">Gashororo</Link><br /><br />
          <Link to="/oasis">Oasis</Link>
        </div>
        <div className="section3-column">
          <Link to="/weiteithie">Weiteithie</Link><br /><br />
          <Link to="/gatundu-road">Gatundu Road</Link>
        </div>
      </div>
    </section>
  );
}

export default Location;
